import * as yup from "yup";

export const EditUserSchema = (states, counties, titleReps, trans) => {
  if (typeof trans !== "function") {
    console.warn(
      "⚠️ Translation function not provided — falling back to English defaults."
    );
    trans = (key) => key;
  }

  return yup.object().shape({
    first_name: yup
      .string()
      .trim()
      .required(trans("validation_first_name_required")),
    last_name: yup
      .string()
      .trim()
      .required(trans("validation_last_name_required")),
    email: yup
      .string()
      .email(trans("validation_email_invalid"))
      .required(trans("validation_email_required")),
    mailing_address: yup
      .string()
      .trim()
      .required(trans("validation_mailing_address_required")),
    city: yup
      .string()
      .matches(/^[a-zA-Z \-']+$/, trans("validation_city_invalid"))
      .required(trans("validation_city_required")),
    state: yup.string().required(trans("validation_state_required")),
    county: yup.string().required(trans("validation_county_required")),
    postal_code: yup
      .string()
      .required(trans("validation_postal_code_required")),
    phone: yup
      .string()
      .required(trans("validation_phone_required"))
      .test(
        "phone-length",
        trans("validation_phone_invalid") ||
          "Phone number must be 10 or 12 digits",
        (value) => {
          if (!value) return false;

          // Remove all non-digit characters
          const digits = value.replace(/\D/g, "");

          // Must be exactly 10 digits (without country code) or 12 digits (with country code)
          return (
            digits.length === 10 || digits.length === 12 || digits.length === 11
          );
        }
      ),
    office_name: yup.string().required(trans("validation_office_required")),
    titlerep: yup.string().required(trans("validation_titlerep_required")),
    dre_nmls: yup.string(),
    corporate_nmls: yup.string(),
  });
};

export const EditSalesUserSchema = (states, counties, titleReps, trans) => {
  if (typeof trans !== "function") {
    console.warn(
      "⚠️ Translation function not provided — falling back to English defaults."
    );
    trans = (key) => key; // fallback to avoid crash
  }

  return yup.object().shape({
    first_name: yup
      .string()
      .trim()
      .required(trans("validation_first_name_required")),
    last_name: yup
      .string()
      .trim()
      .required(trans("validation_last_name_required")),
    email: yup
      .string()
      .email(trans("validation_email_invalid"))
      .required(trans("validation_email_required")),
    mailing_address: yup
      .string()
      .trim()
      .required(trans("validation_mailing_address_required")),
    city: yup
      .string()
      .matches(/^[a-zA-Z \-']+$/, trans("validation_city_invalid"))
      .required(trans("validation_city_required")),
    state: yup.string().required(trans("validation_state_required")),
    county: yup.string().required(trans("validation_county_required")),
    postal_code: yup
      .string()
      .required(trans("validation_postal_code_required")),

    // Updated phone validation to allow 10-12 digits
    phone: yup
      .string()
      .required(trans("validation_phone_required"))
      .test(
        "phone-format",
        trans("validation_phone_invalid") ||
          "Phone number must be 10-12 digits",
        (value) => {
          if (!value) return false;
          // Remove all non-digit characters
          const digits = value.replace(/\D/g, "");
          // Must be between 10 and 12 digits inclusive
          return digits.length >= 10 && digits.length <= 12;
        }
      ),

    //   office_name: yup.string().required(trans("validation_office_required")),
    title: yup.string().required(trans("validation_usertitle_required")),
    titlerep: yup.string().required(trans("validation_titlerep_required")),
    dre_nmls: yup.string(),
    corporate_nmls: yup.string(),
  });
};
